import { render, staticRenderFns } from "./DropDownSchema.vue?vue&type=template&id=456dcb4f&"
import script from "./DropDownSchema.vue?vue&type=script&lang=ts&"
export * from "./DropDownSchema.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports